import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import DynamicViewSchemaProvider from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.tsx";
import { useT } from "src/internationalization";
import BlacklistDetailsPage from "src/pages/Blacklists/BlacklistDetailsPage.tsx";
import BlacklistTab from "src/pages/Blacklists/BlacklistsTab.tsx";

import ErrorBoundary from "../components/Errors/ErrorBoundary";
import BlacklistsPage from "../pages/Blacklists/BlacklistsPage.tsx";

export const useBlacklistsRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "blacklists",
      element: (
        <AuthorizedRoute
          requiredPermissions={[
            { resource: ScopeResource.BLACKLIST_ELEMENT, scopes: [Scope.VIEW] },
          ]}
          pageTitle={t("page.blacklists.title")}
        >
          <DynamicViewSchemaProvider>
            <BlacklistsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: ":code",
          Component: BlacklistTab,
          ErrorBoundary: ErrorBoundary,
        },
      ],
    },
    {
      path: "blacklist/:blacklistCode/:id",
      element: (
        <AuthorizedRoute
          requiredPermissions={[
            { resource: ScopeResource.BLACKLIST_ELEMENT, scopes: [Scope.VIEW] },
          ]}
          //traduire sans s
          pageTitle={t("page.blacklists.title")}
        >
          <DynamicViewSchemaProvider>
            <BlacklistDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "blacklist/:blacklistCode/:id/:code",
      element: (
        <AuthorizedRoute
          requiredPermissions={[
            { resource: ScopeResource.BLACKLIST_ELEMENT, scopes: [Scope.VIEW] },
          ]}
          //traduire sans s
          pageTitle={t("page.blacklists.title")}
        >
          <DynamicViewSchemaProvider>
            <BlacklistDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
